import { React, useEffect, Suspense } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./ProjectGrid.scss";
import Skeleton from "react-loading-skeleton";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ProjectsLoadingSkeleton from "../../../utils/helpers/components/ProjectsLoadingSkeleton";
import DummyProjectImage from "../../../images/dummy-project-image.png";

const ProjectGridList = ({ projects, safeApId, projectType, isLoading }) => {
  // if (projects.length === 0) {
  //   return (
  //     <Row className="project-wrapper-bootstrap project-list-flex row-cols-auto g-3">
  //       <Col>
  //         <div className="project-grid-item">
  //           {/* There are no {projectType} projects! */}
  //         </div>
  //       </Col>
  //     </Row>
  //   );
  // }

  if (isLoading) {
    return <ProjectsLoadingSkeleton />;
  }

  return (
    <>
      {projects.map((project) => (
        <Col key={project._id} xl={4} lg={6} md={6} sm={12}>
          <div className="project-card">
            <Link
              to={{
                pathname: `/projects/profile/${project._id}`,
                state: { safeApId: safeApId },
              }}
            >
              {(project.formData.img &&project.formData.img.length>0) ? (
                <LazyLoadImage
                  alt={`Thumbnail of ${project.formData.projectName}`}
                  src={project.formData.img[0].content}
                  height={280}
                  width={"100%"}
                />
              ) : (
                <LazyLoadImage
                  alt={`Thumbnail of ${project.formData.projectName}`}
                  src={DummyProjectImage}
                  height={280}
                  width={"100%"}
                />
              )}
            </Link>
            <h2 className="project-title">{project.formData.projectName}</h2>
            <p className="project-date">{project.createdAt.split('T')[0]}</p>
            <p className="project-description">{project.formData.description}</p>
          </div>
        </Col>
      ))}
    </>
  );
};

export default ProjectGridList;
